import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function useUpdateTitle() {
  const location = useLocation();

  useEffect(() => {
    const pathTitleMap = {
      '/resume': '브이드림',
      '/resume/write': '이력서 등록 | 브이드림',
      '/resume/read': '이력서 조회 | 브이드림',
      // '/resume/inquiry': '간편문의 | 브이드림',
      '/resume/recruitlist': '채용공고 | 브이드림',
    };

    document.title = pathTitleMap[location.pathname] || '브이드림';
  }, [location]);
}

export default useUpdateTitle;
